export const ASSISTANT_ENDPOINTS = {
    GET_ALL: '/assistants',
    CREATE: '/assistants/create',
    GET_BY_ID: (id: string) => `/assistants/${id}`,
    UPDATE: (id: string) => `/assistants/${id}`,
    DELETE: (id: string) => `/assistants/${id}`,
    GET_VOICES: `/assistants/voices`,
    GET_LANGUAGES: `/assistants/transcriber-languages`,
} as const;
